// Mock data for Additions transactions
// Centralized location for demo mode data

export interface AdditionItem {
  id: string;
  assetId: string;
  assetCode: string;
  assetDescription: string;
  category: string;
  location: string;
  value: number;
  notes?: string;
}

export interface AdditionBatch {
  id: string;
  batchReference: string;
  dateOfRun: string;
  period?: number;
  year?: number;
  periodType: 'current' | 'service';
  status: 'In Progress' | 'Completed';
  notes: string;
  items: AdditionItem[];
  preparedBy: string;
  preparedDate: string;
  postedBy?: string;
  postedDate?: string;
  totalValue: number;
  currency: string;
  createdBy: string;
  createdDate: string;
  modifiedBy: string;
  modifiedDate: string;
}

export const mockAdditionBatches: AdditionBatch[] = [
  {
    id: 'batch-1',
    batchReference: 'ADD-2025-001',
    dateOfRun: '2025-11-15',
    period: 11,
    year: 2025,
    periodType: 'current',
    status: 'Completed',
    notes: 'Q4 IT equipment purchases - laptops and workstations for new hires',
    items: [
      { id: 'item-1', assetId: '1', assetCode: 'COMP-001', assetDescription: 'Dell Latitude 7420 Laptop', category: 'Computer Equipment', location: 'London HQ', value: 1250.00 },
      { id: 'item-2', assetId: '2', assetCode: 'COMP-002', assetDescription: 'HP EliteBook 840', category: 'Computer Equipment', location: 'Manchester Office', value: 1100.00 },
      { id: 'item-3', assetId: '3', assetCode: 'COMP-003', assetDescription: 'Lenovo ThinkPad X1', category: 'Computer Equipment', location: 'London HQ', value: 1500.00 },
    ],
    preparedBy: 'John Smith',
    preparedDate: '2025-11-15T10:30:00',
    postedBy: 'Sarah Johnson',
    postedDate: '2025-11-15T14:20:00',
    totalValue: 45000.00,
    currency: 'GBP',
    createdBy: 'John Smith',
    createdDate: '2025-11-15T10:30:00',
    modifiedBy: 'Sarah Johnson',
    modifiedDate: '2025-11-15T14:20:00',
  },
  {
    id: 'batch-2',
    batchReference: 'ADD-2025-002',
    dateOfRun: '2025-11-10',
    period: 11,
    year: 2025,
    periodType: 'service',
    status: 'Completed',
    notes: 'New office furniture for Manchester expansion',
    items: [
      { id: 'item-4', assetId: '16', assetCode: 'FURN-001', assetDescription: 'Executive Desk - Oak', category: 'Furniture & Fixtures', location: 'Manchester Office', value: 1200.00 },
      { id: 'item-5', assetId: '17', assetCode: 'FURN-002', assetDescription: 'Herman Miller Aeron Chair', category: 'Furniture & Fixtures', location: 'Manchester Office', value: 950.00 },
      { id: 'item-6', assetId: '18', assetCode: 'FURN-003', assetDescription: 'Filing Cabinet - 4 Drawer', category: 'Furniture & Fixtures', location: 'Manchester Office', value: 450.00 },
    ],
    preparedBy: 'Emma Wilson',
    preparedDate: '2025-11-10T09:15:00',
    postedBy: 'Betty Davis',
    postedDate: '2025-11-10T11:45:00',
    totalValue: 12500.00,
    currency: 'GBP',
    createdBy: 'Emma Wilson',
    createdDate: '2025-11-10T09:15:00',
    modifiedBy: 'Betty Davis',
    modifiedDate: '2025-11-10T11:45:00',
  },
  {
    id: 'batch-3',
    batchReference: 'ADD-2025-003',
    dateOfRun: '2025-11-05',
    period: 11,
    year: 2025,
    periodType: 'current',
    status: 'Completed',
    notes: 'Vehicle fleet expansion - new delivery vans',
    items: [
      { id: 'item-7', assetId: '26', assetCode: 'VEH-001', assetDescription: 'Ford Transit Van', category: 'Vehicles', location: 'Birmingham Warehouse', value: 28000.00 },
      { id: 'item-8', assetId: '27', assetCode: 'VEH-002', assetDescription: 'Mercedes Sprinter', category: 'Vehicles', location: 'Birmingham Warehouse', value: 35000.00 },
    ],
    preparedBy: 'Mike Davis',
    preparedDate: '2025-11-05T08:00:00',
    postedBy: 'Sarah Johnson',
    postedDate: '2025-11-05T16:30:00',
    totalValue: 63000.00,
    currency: 'GBP',
    createdBy: 'Mike Davis',
    createdDate: '2025-11-05T08:00:00',
    modifiedBy: 'Sarah Johnson',
    modifiedDate: '2025-11-05T16:30:00',
  },
  {
    id: 'batch-4',
    batchReference: 'ADD-2025-004',
    dateOfRun: '2025-10-28',
    period: 10,
    year: 2025,
    periodType: 'current',
    status: 'Completed',
    notes: 'Warehouse machinery - new forklift and equipment',
    items: [
      { id: 'item-9', assetId: '35', assetCode: 'MACH-001', assetDescription: 'Toyota Forklift 3-Ton', category: 'Machinery', location: 'Birmingham Warehouse', value: 25000.00 },
      { id: 'item-10', assetId: '31', assetCode: 'MACH-002', assetDescription: 'CNC Milling Machine', category: 'Machinery', location: 'Birmingham Warehouse', value: 85000.00 },
    ],
    preparedBy: 'Michael Chen',
    preparedDate: '2025-10-28T07:30:00',
    postedBy: 'Betty Davis',
    postedDate: '2025-10-28T15:45:00',
    totalValue: 110000.00,
    currency: 'GBP',
    createdBy: 'Michael Chen',
    createdDate: '2025-10-28T07:30:00',
    modifiedBy: 'Betty Davis',
    modifiedDate: '2025-10-28T15:45:00',
  },
  {
    id: 'batch-5',
    batchReference: 'ADD-2025-005',
    dateOfRun: '2025-10-20',
    period: 10,
    year: 2025,
    periodType: 'service',
    status: 'Completed',
    notes: 'Edinburgh branch setup - initial equipment',
    items: [
      { id: 'item-11', assetId: '7', assetCode: 'COMP-007', assetDescription: 'MacBook Pro 16"', category: 'Computer Equipment', location: 'Edinburgh Branch', value: 3200.00 },
      { id: 'item-12', assetId: '19', assetCode: 'FURN-004', assetDescription: 'Standing Desk - Electric', category: 'Furniture & Fixtures', location: 'Edinburgh Branch', value: 850.00 },
    ],
    preparedBy: 'Robert Williams',
    preparedDate: '2025-10-20T10:00:00',
    postedBy: 'Sarah Johnson',
    postedDate: '2025-10-20T17:00:00',
    totalValue: 8500.00,
    currency: 'GBP',
    createdBy: 'Robert Williams',
    createdDate: '2025-10-20T10:00:00',
    modifiedBy: 'Sarah Johnson',
    modifiedDate: '2025-10-20T17:00:00',
  },
  {
    id: 'batch-6',
    batchReference: 'ADD-2025-006',
    dateOfRun: '2025-10-15',
    period: 10,
    year: 2025,
    periodType: 'current',
    status: 'Completed',
    notes: 'Server room upgrade - new networking equipment',
    items: [
      { id: 'item-13', assetId: '10', assetCode: 'COMP-010', assetDescription: 'Lenovo ThinkCentre M90', category: 'Computer Equipment', location: 'London HQ', value: 1100.00 },
      { id: 'item-14', assetId: '14', assetCode: 'COMP-014', assetDescription: 'HP Z2 Tower', category: 'Computer Equipment', location: 'London HQ', value: 2200.00 },
    ],
    preparedBy: 'David Wilson',
    preparedDate: '2025-10-15T09:00:00',
    postedBy: 'Betty Davis',
    postedDate: '2025-10-15T14:30:00',
    totalValue: 15800.00,
    currency: 'GBP',
    createdBy: 'David Wilson',
    createdDate: '2025-10-15T09:00:00',
    modifiedBy: 'Betty Davis',
    modifiedDate: '2025-10-15T14:30:00',
  },
  {
    id: 'batch-7',
    batchReference: 'ADD-2024-012',
    dateOfRun: '2024-12-20',
    period: 12,
    year: 2024,
    periodType: 'current',
    status: 'Completed',
    notes: 'Year-end capital expenditure - building improvements',
    items: [
      { id: 'item-15', assetId: '36', assetCode: 'BLDG-001', assetDescription: 'Office Building Annex', category: 'Buildings', location: 'London HQ', value: 150000.00 },
    ],
    preparedBy: 'John Smith',
    preparedDate: '2024-12-20T08:00:00',
    postedBy: 'Sarah Johnson',
    postedDate: '2024-12-20T17:00:00',
    totalValue: 150000.00,
    currency: 'GBP',
    createdBy: 'John Smith',
    createdDate: '2024-12-20T08:00:00',
    modifiedBy: 'Sarah Johnson',
    modifiedDate: '2024-12-20T17:00:00',
  },
  {
    id: 'batch-8',
    batchReference: 'ADD-2024-011',
    dateOfRun: '2024-11-30',
    period: 11,
    year: 2024,
    periodType: 'service',
    status: 'Completed',
    notes: 'Conference room equipment upgrade',
    items: [
      { id: 'item-16', assetId: '22', assetCode: 'FURN-007', assetDescription: 'Conference Table - 12 Seater', category: 'Furniture & Fixtures', location: 'London HQ', value: 2400.00 },
      { id: 'item-17', assetId: '23', assetCode: 'FURN-008', assetDescription: 'Whiteboard - Large', category: 'Furniture & Fixtures', location: 'London HQ', value: 350.00 },
    ],
    preparedBy: 'Emma Wilson',
    preparedDate: '2024-11-30T10:00:00',
    postedBy: 'Betty Davis',
    postedDate: '2024-11-30T15:00:00',
    totalValue: 5500.00,
    currency: 'GBP',
    createdBy: 'Emma Wilson',
    createdDate: '2024-11-30T10:00:00',
    modifiedBy: 'Betty Davis',
    modifiedDate: '2024-11-30T15:00:00',
  },
];
